import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import CancellationPoliciesShared from './CancellationPoliciesShared';
import { restrictUrls } from '../../../helpers/adminPrivileges';

const title = 'Cancellation Policies 2';

export default async function action({ store }) {
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    const adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
    const privileges = store.getState().listSettings && store.getState().listSettings.privileges;

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' };
    }

    // Admin restriction - using same privilege as home page settings (15)
    if (!restrictUrls('/siteadmin/home/cancellation-policies-shared', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }

    return {
        title,
        component: <AdminLayout><CancellationPoliciesShared title={title} /></AdminLayout>,
    };
}
